import React, { FunctionComponent } from 'react';
import { Special } from '../../../types/specials';
import { Paginate } from '../../molecules/paginate';
import { Loading } from '../../atoms/loading';
import classnames from 'classnames';
import { FlashBox } from '../../atoms/flashBox';

type Props = {
  specials: Special[];
  specialsCount: number;
  isLoading: boolean;
  currentPage: number;
  paginatePer: number;
  shouldShowPagination: boolean;
  onPageChange: (newPage: number) => void;
  flash: boolean;
  flashType: string;
  flashMessage: string;
  handleFlash: (flash: boolean, flashType: string, flashMessage: string) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  specials,
  specialsCount,
  isLoading,
  currentPage,
  paginatePer,
  shouldShowPagination,
  onPageChange,
  flash,
  flashType,
  flashMessage,
  handleFlash,
}) => {
  return (
    <div className="special">
      <h1 className="special-title">求人・企業特集一覧</h1>

      <FlashBox
        flash={flash}
        flashType={flashType}
        flashMessage={flashMessage}
        handleFlash={handleFlash}
      />
      <div className={classnames('applicants-loading', 'blur', { 'is-active': isLoading })}>
        <Loading />
      </div>
      <ul className="special-container">
        {specials.map((special) => (
          <li key={special.id} className="special-list">
            <a href={`/specials/${special.id}`} className="special-link">
              <div
                style={{
                  background: `url(${special.coverImage}) no-repeat center center`,
                  backgroundSize: "cover",
                  width: "100%",
                  height: 0,
                  paddingTop: "55.25%",
                }}
              />
              <p className="special-list-type">
                {special.isCompanyContent ? "企業" : "求人"}特集
              </p>
              <h2 className="special-list-title">{special.title}</h2>

              <div className="special-list-info">
                <p className="special-list-company">{special.indexDescription}</p>
                <div className="special-list-numbers">
                  <p className="special-list-numbers-date">{special.updatedAt}</p>
                </div>
              </div>
            </a>
          </li>
        ))}
      </ul>
      {shouldShowPagination && (
        <Paginate
          current={currentPage}
          max={Math.ceil(specialsCount / paginatePer)}
          page="specials"
          handleClick={(page: number) => onPageChange(page)}
        />
      )}
    </div>
  );
};
